import Axios from "axios";
import dayjs from "dayjs";
import React from "react";
import { DataTable, TableBoundary } from "../data-table";
import { PhotoFilter, PhotoFilterState } from "./filter";

interface PhotoProps {}

interface State {
  compNo: string;
  iccNo: string;
  invType: string;
  month: string;

  total: number;
  skip: number;

  data: any[];
  complaint?: Record<string, unknown>[];
  inv?: Record<string, unknown>[];
  attachments?: string[];

  loading: boolean;
}

const take = 100;
export const CaseDetailsPage: React.FC<PhotoProps> = (props) => {
  const [state, setState] = React.useState<State>({
    compNo: "",
    iccNo: "",
    invType: "",
    month: dayjs().subtract(2, "month").format("YYYY-MM"),

    data: [] as any[],
    total: Infinity,
    skip: 0,
    loading: false,
  });

  React.useEffect(() => {
    handleOnBounce({ ...state });
  }, []);

  const onScroll = (bound: TableBoundary) => {
    const { currentHeight, totalHeight } = bound;
    if (totalHeight * 0.6 < currentHeight) {
      handleOnBounce({ ...state });
    }
  };

  const fetchPhoto = (caseNo: string, compNo: string) => {
    Axios.get(`/complaint/photo/details`, {
      params: {
        iccNo: caseNo,
        compNo,
      },
    }).then((res) => {
      setState({
        ...state,
        complaint: res.data[0],
        inv: res.data[1],
        attachments: res.data[2] ? res.data[2].attachments : null,
      });
    });
  };

  const handleOnBounce = (value: PhotoFilterState) => {
    const { invType, month, iccNo, compNo } = value;
    let { total, skip } = state;
    const data = state.data;
    const notSame =
      invType !== state.invType ||
      month !== state.month ||
      iccNo !== state.iccNo ||
      compNo !== state.compNo;

    if (notSame) {
      skip = 0;
      total = Infinity;
    }

    if (total <= data.length) return;

    setState({ ...state, loading: true, invType, month, iccNo, compNo });
    Axios.get("/complaint/photo", {
      params: { invType, iccNo, month, compNo, skip, take },
    })
      .then((res) => {
        const [data, total] = res.data;
        setState((prev) => ({
          ...prev,
          total,
          data: notSame ? data : [...state.data, ...data],
          skip: skip + take,
        }));
      })
      .finally(() => {
        setState((prev) => ({ ...prev, loading: false }));
      });
  };

  return (
    <div className="photo">
      <div className="wrapper">
        <span className="title">complaint</span>
        <div className="container">
          <span className="title">search</span>

          <PhotoFilter
            compNo={state.compNo}
            iccNo={state.iccNo}
            month={state.month}
            invType={state.invType}
            onDebounce={handleOnBounce}
          />

          {state.data.length > 0 && (
            <DataTable
              type="portal-datatable"
              columns={Object.keys(state.data[0]).map((row) => ({
                title: row,
                dataIndex: row,
              }))}
              data={state.data}
              onScroll={onScroll}
              onClick={(row, unselect) => {
                if (unselect) {
                  setState({
                    ...state,
                    inv: undefined,
                    complaint: undefined,
                    attachments: undefined,
                  });
                } else fetchPhoto(row.ICC_NO, row.COMP_NO);
              }}
            />
          )}
        </div>
      </div>

      <div className="details">
        {state.attachments && (
          <>
            <span className="subheader">detail</span>
            <div className="photos">
              {state.attachments.map((row) => (
                <img alt="" src={`http://wcis.1823.gov.hk/${row}`} key={row} />
              ))}
            </div>
          </>
        )}

        {state.complaint && (
          <DataTable
            columns={Object.keys(state.complaint[0]).map((row) => ({
              title: row,
              dataIndex: row,
            }))}
            data={state.complaint}
            onScroll={onScroll}
          />
        )}

        {state.inv && (
          <DataTable
            columns={Object.keys(state.inv[0]).map((row) => ({
              title: row,
              dataIndex: row,
            }))}
            data={state.inv}
            onScroll={onScroll}
          />
        )}
      </div>
    </div>
  );
};
